/**
 * Brand Constants
 * Add your brand details here.
 */
const title = process.env.NODE_ENV == "production" ? "NeighborCloud" : "DEV: NeighborCloud";
export const siteConfig = {
  siteTitle: title,
  siteDescription:
    'Your neighborhood association in the cloud.',
  siteUrl: 'https://neighborcloud.app',
  siteImage: '/images/og-image.png',
  favicon: '/favicon.ico',
  twitterHandle: '@neighborcloud.app',
  email: 'hello@neighborcloud.app',
  address: '',
}
